export enum ResponseError {
    'general_error' = 'general_error',
    'email_not_found' = 'email_not_found',
}